import { Lead } from "@kanda-libs/ks-frontend-services";

export const formatAddress = (lead?: Lead) => ({
  buildingName:
    lead?.lead_applicant?.customer_details?.current_address?.building_name,
  buildingNumber:
    lead?.lead_applicant?.customer_details?.current_address?.building_number,
  line1:
    lead?.lead_applicant?.customer_details?.current_address?.line_1 ||
    "Not added",
  line2: lead?.lead_applicant?.customer_details?.current_address?.line_2,
  city:
    lead?.lead_applicant?.customer_details?.current_address?.city ||
    "Not added",
  postcode:
    lead?.lead_applicant?.customer_details?.current_address?.postcode ||
    "Not added",
});

export const formatAddressAsString = (lead?: Lead): string =>
  [
    lead?.lead_applicant?.customer_details?.current_address?.building_name,
    lead?.lead_applicant?.customer_details?.current_address?.building_number,
    lead?.lead_applicant?.customer_details?.current_address?.line_1,
    lead?.lead_applicant?.customer_details?.current_address?.line_2,
    lead?.lead_applicant?.customer_details?.current_address?.city,
    lead?.lead_applicant?.customer_details?.current_address?.postcode,
  ]
    .filter(Boolean)
    .join(",");
